import { c as _c } from "react/compiler-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Photo } from "react-photo-album";
const iconError = "/img/picto-error-red.svg";
const iconSuccess = "/img/picto-valid-green.svg";
import { usePhotoDelete } from "../../../hooks/use-photo-delete";
interface DeletePhotosProps {
  clubSlug: string;
  photo: {
    id: string;
    src: string;
  };
  setIsDeletePending: (isDeletePending: boolean) => void;
  setPhotoToDelete: (photoToDelete: (Photo & {
    id: string;
  }) | null) => void;
}
export const DeletePhotos = t0 => {
  const $ = _c(43);
  const {
    clubSlug,
    photo,
    setIsDeletePending,
    setPhotoToDelete
  } = t0;
  const [disabled, setDisabled] = useState(false);
  const {
    mutate: deletePhoto,
    isPending,
    error: deleteError,
    isSuccess: deleteSuccess
  } = usePhotoDelete(clubSlug);
  let t1;
  if ($[0] !== deletePhoto || $[1] !== photo.id) {
    t1 = () => {
      deletePhoto(photo.id);
    };
    $[0] = deletePhoto;
    $[1] = photo.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDelete = t1;
  let t2;
  if ($[3] !== setIsDeletePending || $[4] !== setPhotoToDelete) {
    t2 = () => {
      setIsDeletePending(false);
      setPhotoToDelete(null);
    };
    $[3] = setIsDeletePending;
    $[4] = setPhotoToDelete;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleCancel = t2;
  let t3;
  let t4;
  if ($[6] !== deleteError || $[7] !== isPending) {
    t3 = () => {
      if (isPending || deleteError) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    };
    t4 = [isPending, deleteError];
    $[6] = deleteError;
    $[7] = isPending;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  if (deleteSuccess) {
    setTimeout(() => {
      handleCancel();
    }, 2000);
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="text-3xl font-bold">Suppression de la photo</h1>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      backgroundColor: "#fefaf5",
      width: "600px",
      margin: "20px auto",
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    };
    t7 = <p>Voulez-vous vraiment supprimer cette photo ?</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isPending) {
    t8 = isPending && <CircularProgress sx={{
      color: "#EE4540"
    }} />;
    $[13] = isPending;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== deleteError) {
    t9 = deleteError && <div className="flex flex-col items-center"><Image src={iconError} alt="erreur" width={50} height={50} /><p style={{
        color: "red",
        marginTop: "10px"
      }}>Une erreur est survenue. <br /> La photo n'a pas pu être supprimée.</p></div>;
    $[15] = deleteError;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== deleteSuccess) {
    t10 = deleteSuccess && <div className="flex flex-col items-center"><Image src={iconSuccess} alt={"succ\xE8s"} width={50} height={50} /><p style={{
        color: "#00ba85",
        marginTop: "10px"
      }}>Photo supprimée avec succès.</p></div>;
    $[17] = deleteSuccess;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== deleteError || $[20] !== deleteSuccess || $[21] !== isPending || $[22] !== photo.src) {
    t11 = !isPending && !deleteError && !deleteSuccess && <Image src={photo?.src || ""} alt="add photo" width={200} height={200} className="rounded-md" />;
    $[19] = deleteError;
    $[20] = deleteSuccess;
    $[21] = isPending;
    $[22] = photo.src;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = <div className="flex justify-center">{t8}{t9}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== handleCancel) {
    t13 = <button className="text-black px-4 py-2 rounded-md" onClick={handleCancel}>Annuler</button>;
    $[29] = handleCancel;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = disabled ? "grey" : "#EE4540";
  let t15;
  if ($[31] !== t14) {
    t15 = {
      backgroundColor: t14
    };
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== disabled || $[34] !== handleDelete || $[35] !== t15) {
    t16 = <button className="text-white px-4 py-2 rounded-md" style={t15} onClick={handleDelete} disabled={disabled}>Supprimer</button>;
    $[33] = disabled;
    $[34] = handleDelete;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t16) {
    t17 = <div className="flex justify-center gap-10">{t13}{t16}</div>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t12 || $[41] !== t17) {
    t18 = <div className="text-center">{t5}<div className="flex flex-wrap justify-around gap-4 p-5 w-full" style={t6}>{t7}{t12}{t17}</div></div>;
    $[40] = t12;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
};